import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||77}
    height={undefined}
    viewBox="0 0 77 74"
    style={{aspectRatio: 77/74}}
    fill="none"
    {...props}
  >
    <path
      fill="#24EAA8"
      d="M0 73.735V8.638C0 3.874 3.874 0 8.638 0h58.755c4.761 0 8.638 3.874 8.638 8.638v40.906c0 4.761-3.873 8.638-8.638 8.638H15.556L0 73.735ZM8.638 5.46A3.18 3.18 0 0 0 5.46 8.638v51.916l7.832-7.832H67.39a3.18 3.18 0 0 0 3.177-3.178V8.638A3.18 3.18 0 0 0 67.39 5.46H8.638Z"
    />
    <path
      fill="#425596"
      d="M30.625 39.35c-1.3 0-2.45-.367-3.45-1.1-.983-.733-1.758-1.825-2.325-3.275-.55-1.45-.825-3.242-.825-5.375s.275-3.908.825-5.325c.567-1.417 1.342-2.475 2.325-3.175 1-.7 2.15-1.05 3.45-1.05 1.317 0 2.467.358 3.45 1.075.983.7 1.75 1.758 2.3 3.175.55 1.4.825 3.167.825 5.3s-.275 3.925-.825 5.375c-.55 1.45-1.317 2.542-2.3 3.275-.983.733-2.133 1.1-3.45 1.1Zm0-3.45c.45 0 .85-.167 1.2-.5.367-.35.65-.975.85-1.875.217-.917.325-2.225.325-3.925 0-1.7-.108-2.992-.325-3.875-.2-.883-.483-1.483-.85-1.8a1.738 1.738 0 0 0-1.2-.475c-.433 0-.833.158-1.2.475-.367.317-.658.917-.875 1.8-.217.883-.325 2.175-.325 3.875 0 1.7.108 3.008.325 3.925.217.9.508 1.525.875 1.875.367.333.767.5 1.2.5ZM46.609 39V28.25c0-.583.017-1.267.05-2.05.05-.8.084-1.5.1-2.1h-.1a68.027 68.027 0 0 1-1.5 3.2l-2.125 3.675h9.775v3.375H38.784v-3.075l6.475-10.9h5.5V39h-4.15Z"
    />
  </svg>
)
export default SvgComponent
